import { createRouter, createWebHashHistory } from "vue-router";
import HomePage from "../views/HomePage.vue";
import QuizPageOne from "../views/QuizPageOne.vue";
import QuizResultsPage from "../views/QuizResultsPage.vue";
import MethodDetails from "../views/MethodDetails.vue";
import Admin from "../views/Admin.vue";

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
  },
  {
    path: "/QuizPageOne",
    name: "QuizPageOne",
    component: QuizPageOne,
  },
  {
    path: "/QuizResultsPage",
    name: "QuizResultsPage",
    component: QuizResultsPage,
  },
  {
    path: "/MethodDetails/:choice",
    name: "Method Details",
    component: MethodDetails,
    props: true,
  },
  {
    path: "/Admin",
    name: "Admin",
    component: Admin,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
